module.exports = __webpack_public_path__ + "img/company_logo.4f03c18e.png";